declare var require: (arg0: string) => { (): any; new(): any; version: any; };
export const environment = {
  production: false,
  version: require('../../package.json').version,

  appname: 'CV Online Sales',
  truckLobId: 'Icv Trucks',
  busLobId: 'Buses',
  SCVPickupsLobId: 'SCV Pickups',


  //sandbox

  // apiUrl  : "https://skindevreplica.api.tatamotors/",
  // baseUrl : "https://buytrucknbus-OSP3Dev.home.tatamotors",  //5000 dev
  // // baseUrl : "https://buytrucknbus-OSP3QA.home.tatamotors",  //8000 qa
  // // baseUrl : "https://buytrucknbus-OSPDev.home.tatamotors", //3000 qa
  // cleverTapConfig: {
  //   projectName: "CV_Online_QA",
  //   ctc: "TEST-44Z-4K5-6K6Z",
  //   VAPID_PB_CC: "BEQwSGIVHacvuT5zyye0sdTVeA_HRm7sOKAu51OXLQlSk9_2Wxow9XZNG7i2jIBDiJiyiTb8_JGMf_qlqrfaYhY",
  //   VAPID_PR_CC: "teaTWkYJPKZ90v_gB-6qce9_7Nljsts1EWHMxGDZ9-k"
  // },
  // anuvadakTransliterate: {
  //   avc: "e7bbb1f885c0045c4616c7b0da2667539ba455fc ",
  //   appId: "com.tatamotors"
  // },
  // s3bucket: {
  //   url: "https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/"
  // },
  // ccavenueType:"sandbox",
  // ProdSandboxLink: false,
  // confAWSurl: "https://d1t6fngbwb760h.cloudfront.net/prod/public_images",
  // confAWS3Durl: "https://d1t6fngbwb760h.cloudfront.net/prod",
  // // //5000 QA //8000
  // configurationurl: "https://skindevreplica.api.tatamotors/api/v1/osp_configurator/",
  // FNIBaseURL:"api/fni/",

  // ---------------------- QA Env URLs //5000 QA ----------------------
  // BASE_URL: "https://skindevreplica.api.tatamotors/api/fni/",
  // AUTH_BASE_URL: "https://skindevreplica.api.tatamotors/api/login/",
  // REDIRECT_URL: "https://fni-dev.home.tatamotors/FNI",
  // AUTH_TOKEN: 'Basic Y3ZwLXVzZXItMTpwbHV0b2lzbm90YXBsYW5ldA==',
  // SAHAJ_BASE_URL: 'https://fni-dev-new.api.tatamotors/fni-service/public/',
  // env_stage: "dev",



//------------------ QA Env URLs //8000 QA----------------------
  // BASE_URL: "https://skincicdqa.api.tatamotors/api/fni/",
  // AUTH_BASE_URL: "https://skincicdqa.api.tatamotors/api/login/",
  // REDIRECT_URL: "https://fni-qa.home.tatamotors",
  // AUTH_TOKEN: 'Basic Y3ZwLXVzZXItMTpwbHV0b2lzbm90YXBsYW5ldA==',
  // SAHAJ_BASE_URL: 'https://fni-staging.api.tatamotors/fni-service/public/',
  // env_stage: "qa",


// --------------mobility changes start -----------//3000 dev -------
  // apiUrl  :  "https://mobility-cv-dev-microservices.api.tatamotors/",
  // configurationurl: "https://mobility-cv-dev-microservices.api.tatamotors/api/v1/cv_online/v1/osp_configurator/",
  // BASE_URL: "https://mobility-cv-dev-microservices.api.tatamotors/api/v1/cv_online/fni/",
  // AUTH_BASE_URL: "https://mobility-cv-dev-microservices.api.tatamotors/api/v1/cv_online/login/",
  // SAHAJ_BASE_URL: 'https://fni-staging.api.tatamotors/fni-service/public/',
  // FNIBaseURL : "api/v1/cv_online/fni/",
  // env_stage: "dev",



// configurationurl: "https://digital-osp-cv-dev-ms.api.tatamotors/api/v1/cv_online/v1/osp_configurator/",

  // apiUrl  :  "https://digital-osp-cv-dev-ms.api.tatamotors/",
  // configurationurl: "https://digital-osp-cv-dev-ms.api.tatamotors/api/configurator/",
  // BASE_URL: "https://digital-osp-cv-dev-ms.api.tatamotors/api/v1/cv_online/fni/",
  // AUTH_BASE_URL: "https://digital-osp-cv-dev-ms.api.tatamotors/api/v1/cv_online/login/",
  // SAHAJ_BASE_URL: 'https://fni-staging.api.tatamotors/fni-service/public/'

// --------------mobility changes end-------------

  //------------ unused--------------//

  // firebaseConfig: {
  //   apiKey: "AIzaSyD8WdfmokFb58obk5UXSz-Gwkpgx17bG-o",
  //   authDomain: "cv-online-sales-portal-sandbox.firebaseapp.com",
  //   databaseURL: "https://cv-online-sales-portal-sandbox-default-rtdb.firebaseio.com",
  //   projectId: "cv-online-sales-portal-sandbox",
  //   storageBucket: "cv-online-sales-portal-sandbox.appspot.com",
  //   messagingSenderId: "594105710451",
  //   appId: "1:594105710451:web:4acef8c3d49b6c0b0db706",
  //   measurementId: "G-L11KEG18ES"
  // },


  // baseUrl : "http://localhost:4200",
  // apiUrl  : "https://skinqa-cv.api.tatamotors:8080/",  //qa -- cvdirect
  // baseUrl : "https://ibpodev.home.tatamotors/CV_Online_Sales",
  // baseUrl : "https://ibpodev.home.tatamotors/OSPQA",



  ///////////////////         Sandbox End     ///////////////////



  //////////////////////////////////
  /////     production    4000   ///
  /////////////////////////////////

   apiUrl  : "https://digital-osp-cv-prod-ms.api.tatamotors/",
   baseUrl : "https://fleetverse.tatamotors.com/",
   cleverTapConfig: {
    projectName : "CV_Online_Prod",
    ctc : "RZZ-8Z6-6K6Z"
   },
    anuvadakTransliterate : {
      avc : "ad13fcc7a56ef1d843aa5b140d1594726bb4169a",
    appId : "prod.tatamotors"
     },
   s3bucket : {
    url : "https://d3bslevwxw022c.cloudfront.net/buytrucknbus-tatamotors-com/cv/cv_online/"
   },
  ccavenueType:"production",

  // //---------------- Production Env URLs ------------------------// // //

  FNIBaseURL:"api/fni/",
  // BASE_URL: "https://digital-osp-cv-prod-ms.api.tatamotors/api/fni/",
  // AUTH_BASE_URL: "https://digital-osp-cv-prod-ms.api.tatamotors/api/login/",
  // REDIRECT_URL: "https://fni.home.tatamotors",
  // AUTH_TOKEN: 'Basic Y3ZwLXVzZXItMTpwbHV0b2lzbm90YXBsYW5ldA==',
  // SAHAJ_BASE_URL: 'https://fni.api.tatamotors/fni-service-public/',
  // env_stage: "production",

  // //----------------Qa Prod build ----------------------// // //
  BASE_URL: "https://digital-osp-cv-prod-ms.api.tatamotors/api/v1/cv_online/fni/",
   AUTH_BASE_URL: "https://digital-osp-cv-prod-ms.api.tatamotors/api/login/",
   REDIRECT_URL: "https://fni.home.tatamotors",
   AUTH_TOKEN: 'Basic Y3ZwLXVzZXItMTpwbHV0b2lzbm90YXBsYW5ldA==',
   SAHAJ_BASE_URL: 'https://fni.api.tatamotors/fni-service/public/',
   env_stage: "production",
   FNI_End_Url:"api/v1/cv_online/fni",
   apiUrlProd:"https://skinprod.api.tatamotors/",


  // //----------------- CONFIGURATOR URL SANDBOX -----------------------// // //
  configurationurl: "https://digital-osp-cv-prod-ms.api.tatamotors/api/configurator/",
  ProdSandboxLink: true,
  confAWSurl: "https://d1t6fngbwb760h.cloudfront.net/prod/public_images",
  confAWS3Durl: "https://d1t6fngbwb760h.cloudfront.net/prod",

};
